import styles from './style.module.scss';
import { Typography, Space, Divider, Row, Col, Avatar, Card } from 'antd';
import { Button } from 'components';
import { UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useSsoUsers } from '../useSsoUsers';
import { Fragment, useCallback } from 'react';

const Single = () => {
  const { t } = useTranslation();
  const { singleItem, navigate, pathname, loading } = useSsoUsers(false);

  const onClickEdit = useCallback(() => {
    navigate(`${pathname}/edit`);
  }, [navigate, pathname]);

  return (
    <div>
      {/*<PageHeader title={title} />*/}
      <div className={styles.content}>
        <Card loading={loading} title={singleItem?.user?.surname_name}>
          <Card.Grid hoverable={false} className={styles.leftSide}>
            <Space direction={'vertical'} align={'center'}>
              <Avatar size={100} icon={<UserOutlined />} />
              <Button onClick={onClickEdit}>{t('MODIFICA')}</Button>
              {/*TODO add role*/}
              <Typography.Title level={3}>
                {singleItem?.user_role?.title}
              </Typography.Title>
            </Space>
          </Card.Grid>
          <Card.Grid className={styles.rightSide} hoverable={false}>
            <Row>
              <Col flex='200px'>
                <Typography.Title level={5}>{t('Email')}:</Typography.Title>
              </Col>
              <Col>{singleItem?.user?.email}</Col>
            </Row>
            <Row>
              <Col flex='200px'>
                <Typography.Title level={5}>{t('Insegna')}:</Typography.Title>
              </Col>
              <Col>{singleItem?.chain?.title}</Col>
            </Row>
            <Divider />
            <Typography.Title level={4}>
              {t('ULTIME 15 OPERAZIONI')}
            </Typography.Title>
            <Row wrap={false}>
              <Col flex='200px'>
                <Typography.Title level={5}>{t('Date')}</Typography.Title>
              </Col>
              <Col flex={'auto'}>
                <Typography.Title level={5}>{t('Azione')}</Typography.Title>
              </Col>
              <Col className={styles.type} span={2}>
                <Typography.Title level={5}>{t('Tipo')}</Typography.Title>
              </Col>
            </Row>
            <Divider />
            {singleItem?.gdprlogs?.map((value, index) => (
              <Fragment key={index.toString()}>
                <Row wrap={false}>
                  <Col flex='200px'>
                    <Typography level={5}>{value.created_at}</Typography>
                  </Col>
                  <Col flex={'auto'}>
                    <Typography level={5}>{value.request_url}</Typography>
                  </Col>
                  <Col className={styles.type} span={2}>
                    {value.request_type}
                  </Col>
                </Row>
                <Divider />
              </Fragment>
            ))}
          </Card.Grid>
        </Card>
      </div>
    </div>
  );
};

export default Single;
